var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseStringIdDataDto } from '../../../classes/common';
import { ReservationHistoryDto } from '../../../classes/reservation-history/response/reservation-history.dto';
import { VendorWithoutRelationsDto } from '../../../classes/vendor/response/vendor-without-relations.dto';
import { VehicleModelWithoutRelationsDto } from '../../vehicle-model';
export class ReservationWithHistoryDto extends BaseStringIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.pickUpAt = initializer.pickUpAt;
        this.dropOffAt = initializer.dropOffAt;
        this.state = initializer.state;
        this.vendor = initializer.vendor;
        this.vendorId = initializer.vendorId;
        this.customerName1 = initializer.customerName1;
        this.customerName2 = initializer.customerName2;
        this.vehicleModelId = initializer.vehicleModelId;
        this.vehicleModel = initializer.vehicleModel;
        this.canceledAt = initializer.canceledAt;
        this.histories = initializer.histories;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationWithHistoryDto.prototype, "pickUpAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationWithHistoryDto.prototype, "dropOffAt", void 0);
__decorate([
    Type(() => VendorWithoutRelationsDto),
    __metadata("design:type", VendorWithoutRelationsDto)
], ReservationWithHistoryDto.prototype, "vendor", void 0);
__decorate([
    Type(() => VehicleModelWithoutRelationsDto),
    __metadata("design:type", VehicleModelWithoutRelationsDto)
], ReservationWithHistoryDto.prototype, "vehicleModel", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationWithHistoryDto.prototype, "canceledAt", void 0);
__decorate([
    Type(() => ReservationHistoryDto),
    __metadata("design:type", Array)
], ReservationWithHistoryDto.prototype, "histories", void 0);
